import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthApiService } from 'src/app/services/api/auth-api.service';
import { CertificadoInacalApiService } from 'src/app/services/api/certificado-inacal-api.service';
import { Subscription } from 'rxjs';
import { OneDriveService } from 'src/app/services/core/onedrive.service';
import { OnedriveService } from 'src/app/services/api/onedrive-api.service';

@Component({
  selector: 'app-certificados',
  templateUrl: './certificados.component.html',
  styleUrls: ['./certificados.component.scss']
})

export class CertificadosComponent implements OnInit {

  isLoading = false;
  loadingText = 'Consultando certificado...';


  certificadoForm: FormGroup;
  urlPDF: SafeResourceUrl | null = null;
  codigoHash: string | null = null;
  view = true;
  showProjectFields = false;
  showRedirectMessage = false;
  redirectUrl = '';
  private routeSub: Subscription;
  proyectosConfig = [
    { proyecto: "VRF CHICLAYO", fechaInicio: "01/12/2025" },
    { proyecto: "VRF HUANCAYO", fechaInicio: "10/11/2028" },
    { proyecto: "VRF IQUITOS", fechaInicio: "10/11/2028" },
    { proyecto: "VRF JAEN", fechaInicio: "10/11/2028" },
    { proyecto: "VRF LUZ DEL SUR", fechaInicio: "01/09/2025" },
    { proyecto: "VRF PIURA", fechaInicio: "01/09/2025" },
    { proyecto: "VRF PLUZ ENERGIA", fechaInicio: "01/09/2025" },
    { proyecto: "VRF PUNO", fechaInicio: "03/11/2025" },
    { proyecto: "VRF TARAPOTO", fechaInicio: "10/11/2028" },
    { proyecto: "VRF TRUJILLO", fechaInicio: "10/11/2028" },
    { proyecto: "VRF UCAYALI", fechaInicio: "10/11/2028" }
  ];

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private router: Router,
    private certificadoService: CertificadoInacalApiService,
    private authService: AuthApiService,
    private onedriveService: OnedriveService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar) {
      //console.log("CertificadosComponent / constructor...");
     }

    ngOnInit(): void {
      //console.log("CertificadosComponent / ngOnInit$$...");
      this.routeSub = this.route.paramMap.subscribe(params => {
        this.codigoHash = params.get('codigoHash');
        //console.log("CertificadosComponent / ngOnInit - codigoHash", this.codigoHash);
        this.buildForm();
      });
      //console.log("CertificadosComponent / llamando a TestTOKEN...");
      this.testToken();
      //console.log("CertificadosComponent / Finalizando TestTOKEN...");
    }
  
    ngOnDestroy(): void {
      //console.log("CertificadosComponent / ngOnDestroy...");
      this.routeSub.unsubscribe();
    }

 
    private buildForm(): void {
      // Si hay codigoHash, mantenemos la lógica original
      if (this.codigoHash) {
        this.certificadoForm = this.fb.group({
          CODIGO_SEGURIDAD: ['', Validators.required]
        });
      } else {
        // Sin codigoHash, mostramos campos de proyecto y fecha primero
        this.certificadoForm = this.fb.group({
          PROYECTO: ['', Validators.required],
          FECHA: ['', Validators.required],
          NRO_CERTIFICADO: [''],
          NRO_SUMINSTRO: ['']
        });
        
        // Escuchar cambios en proyecto y fecha para validar redirección
        this.certificadoForm.get('PROYECTO')?.valueChanges.subscribe(() => this.validarRedireccion());
        this.certificadoForm.get('FECHA')?.valueChanges.subscribe(() => this.validarRedireccion());
      }
    }
  
    private validarRedireccion(): void {
      const proyecto = this.certificadoForm.get('PROYECTO')?.value;
      const fecha = this.certificadoForm.get('FECHA')?.value;
      
      if (proyecto && fecha) {
        const proyectoConfig = this.proyectosConfig.find(p => p.proyecto === proyecto);
        
        if (proyectoConfig) {
          const fechaSeleccionada = new Date(fecha);
          const fechaInicio = this.convertirFecha(proyectoConfig.fechaInicio);
          
          if (fechaSeleccionada >= fechaInicio) {
            // Redirigir a URL específica (aquí debes poner la URL que necesites)
            
            this.redirectUrl = "https://inspectionviewtdem.giadatatechnology.com";
            //window.location.href = urlRedireccion;
            this.mostrarMensajeRedireccion();
            return;
          }
        }
        
        // Si no cumple condiciones para redirección, mostrar campos adicionales
        this.showProjectFields = true;
        this.certificadoForm.get('NRO_CERTIFICADO')?.setValidators([Validators.required]);
        this.certificadoForm.get('NRO_SUMINSTRO')?.setValidators([Validators.required]);
        this.certificadoForm.get('NRO_CERTIFICADO')?.updateValueAndValidity();
        this.certificadoForm.get('NRO_SUMINSTRO')?.updateValueAndValidity();
      } else {
        this.showProjectFields = false;
        this.certificadoForm.get('NRO_CERTIFICADO')?.clearValidators();
        this.certificadoForm.get('NRO_SUMINSTRO')?.clearValidators();
        this.certificadoForm.get('NRO_CERTIFICADO')?.updateValueAndValidity();
        this.certificadoForm.get('NRO_SUMINSTRO')?.updateValueAndValidity();
      }
    }
  
    private mostrarMensajeRedireccion(): void {
      // Mostrar el mensaje de redirección
      this.showRedirectMessage = true;
      
      // Opcional: Mostrar un snackbar adicional
      this.openSnackBar(`Redirigiendo a la plataforma InspectionView...`, 'Cerrar');
      
      // Redirigir después de 3 segundos (puedes ajustar el tiempo)
      setTimeout(() => {
        window.location.href = this.redirectUrl;
      }, 3000);
    }
  
    private convertirFecha(fechaString: string): Date {
      const [dia, mes, anio] = fechaString.split('/').map(Number);
      return new Date(anio, mes - 1, dia);
    }

    private async verificarAutenticacion(): Promise<boolean> {
      if (!this.authService.isAuthenticated()) {
        //console.log('No hay token, realizando login automático...');
        try {
          const loginExitoso = await this.authService.login('WEB', 'DGONZALES', '123Tdem').toPromise();
          if (!loginExitoso) {
            this.openSnackBar('Error de autenticación', 'Cerrar');
            return false;
          }
          //console.log('Token obtenido:', this.authService.getToken()); // 👈 Muestra el token
          return true;
        } catch (error) {
          console.error('Error en login automático:', error);
          this.openSnackBar('Error en autenticación automática', 'Cerrar');
          return false;
        }
      }
      //console.log('Token válido existente:', this.authService.getToken()); // 👈 Muestra el token
      return true;
    }
    testToken() {
      //console.log('Token actual:', this.authService.getToken());
      //console.log('¿Autenticado?:', this.authService.isAuthenticated());
    }
  async onSubmit() {
    /*//console.log("CertificadosComponent / onSubmit...");
    const autenticado = await this.verificarAutenticacion();
    //console.log("CertificadosComponent / onSubmit - autenticado", autenticado);
    if (!autenticado) return;

      if (!this.codigoHash) {
        //console.log("CertificadosComponent / onSubmit - Verificar datos de VRF");
        this.verificarDatosVRF();
      }else{
        this.verificarDatosVRI();
        //console.log("CertificadosComponent / onSubmit - Verificar datos de VRI");
      }*/
     
    if (this.isLoading) return;

    this.isLoading = true;
    this.loadingText = 'Validando acceso...';

    try {
      const autenticado = await this.verificarAutenticacion();
      if (!autenticado) return;

      this.loadingText = 'Consultando certificado...';

      if (!this.codigoHash) {
        await this.verificarDatosVRF();
      } else {
        await this.verificarDatosVRI();
      }
    } finally {
      // OJO: En VRF cuando es OneDrive, el "fin" real lo sabremos en el subscribe,
      // así que aquí solo lo apagamos si ya no estamos en proceso de descarga.
      // Para eso lo apagaremos en findCertificado() correctamente.
    }
  }

  private async verificarDatosVRI() {
    //console.log("CertificadosComponent / verificarDatosVRI...");
    const { CODIGO_SEGURIDAD } = this.certificadoForm.value;
  
    if (!CODIGO_SEGURIDAD) {
      this.openSnackBar("Para continuar debe ingresar el código seguridad.", "");
      return;
    }
  
    //console.log("CertificadosComponent / verificarDatosVRI - Buscar registro del certificado", CODIGO_SEGURIDAD, this.codigoHash);
    await this.findCertificado(CODIGO_SEGURIDAD, this.codigoHash, null, null);
  }
  
  private async verificarDatosVRF() {
    //console.log("CertificadosComponent / verificarDatosVRF...");
    const { NRO_CERTIFICADO, NRO_SUMINSTRO } = this.certificadoForm.value;

    if (!NRO_CERTIFICADO || !NRO_SUMINSTRO) {
      this.openSnackBar("Para continuar debe ingresar el número del certificado y suministro.", "");
      return;
    }

    //console.log("CertificadosComponent / verificarDatosVRF - Buscar registro del certificado", NRO_CERTIFICADO, NRO_SUMINSTRO);
    const NRO_SUMINSTRO_SIN_CEROS = Number(NRO_SUMINSTRO).toString();
    await this.findCertificado(null, null, NRO_CERTIFICADO, NRO_SUMINSTRO_SIN_CEROS);
  }
  private async findCertificado(
    codigoSeguridad: string | null,
    codigoHash: string | null,
    nroCertificado: string | null,
    nroSuministro: string | null
  ) {
    this.isLoading = true;
    this.loadingText = 'Buscando información del certificado...';
  
    try {
      const list: any = await this.certificadoService.getPromiseInicial(
        nroCertificado,
        nroSuministro,
        codigoHash,
        codigoSeguridad
      );
  
      // Validación robusta de respuesta
      if (!Array.isArray(list) || list.length === 0) {
        this.openSnackBar("No se encontró el certificado con los datos ingresados.", "");
        this.isLoading = false;
        return;
      }
  
      const item = list[0];
      console.log("item", item);
      // Si es VRI: suele venir con URL directa
      
      console.log("item.TIPO_SERVICIO", item.TIPO_SERVICIO, !item.TIPO_SERVICIO);
      if (item.TIPO_SERVICIO === "VRI") {
        if (!item.URL_CERTIFICADO) {
          this.openSnackBar("El certificado no tiene URL disponible.", "");
          this.isLoading = false;
          return;
        }
  
        this.loadingText = 'Cargando PDF...';
        this.urlPDF = await this.sanitizarURL(item.URL_CERTIFICADO);
        this.view = false;
        this.isLoading = false;
        return;
      }
  
      console.log("item.RUTA_ONE_DRIVE", item.RUTA_ONE_DRIVE, !item.RUTA_ONE_DRIVE);
      // Si es VRF: descargar desde OneDrive
      if (!item.RUTA_ONE_DRIVE) {
        this.openSnackBar("No existe ruta de OneDrive para este certificado.", "");
        this.isLoading = false;
        return;
      }
  
      const loginExitoso = await this.authService.login('WEB', 'DGONZALES', '123Tdem').toPromise();
      this.loadingText = 'Obteniendo acceso a OneDrive...';
      const tokenOneDrive = await this.onedriveService.getTokenOneDrive(1, 1, 'WEB', 'DGONZALES');
      console.log("tokenOneDrive", tokenOneDrive);
  
      if (!tokenOneDrive || !tokenOneDrive.accessToken) {
        this.openSnackBar("No se pudo obtener token de OneDrive.", "");
        this.isLoading = false;
        return;
      }
  
      this.loadingText = 'Preparando descarga...';
  
      // Corregir ruta (tu lógica original)
      let rutaCorregida = "";
      if (String(item.RUTA_ONE_DRIVE).includes(item.NRO_CERTIFICADO)) {
        rutaCorregida = String(item.RUTA_ONE_DRIVE).replace(item.NRO_CERTIFICADO, item.SUMINISTRO);
      } else {
        rutaCorregida = item.RUTA_ONE_DRIVE;
      }
  
      const ultimaBarra = rutaCorregida.lastIndexOf("/");
      if (ultimaBarra === -1) {
        this.openSnackBar("La ruta de OneDrive es inválida.", "");
        this.isLoading = false;
        return;
      }
  
      const ruta = rutaCorregida.substring(0, ultimaBarra);
      const archivo = rutaCorregida.substring(ultimaBarra + 1);
  
      if (!ruta || !archivo) {
        this.openSnackBar("No se pudo determinar la ruta/archivo de OneDrive.", "");
        this.isLoading = false;
        return;
      }
  
      const oneDriveParams = {
        idUserOneDrive: 'b98e8622-72e8-482c-ab22-67bba826531e',
        ruta,
        fileName: archivo
      };
  
      this.loadingText = 'Descargando PDF desde la nube...';
  
      this.onedriveService
        .getFileFromOneDrive(
          oneDriveParams.idUserOneDrive,
          oneDriveParams.ruta,
          oneDriveParams.fileName,
          tokenOneDrive.accessToken
        )
        .subscribe({
          next: async (blobPDF: Blob) => {
            try {
              const blobUrl = URL.createObjectURL(blobPDF);
              this.urlPDF = await this.sanitizarURL(blobUrl);
              this.view = false;
            } catch (e) {
              console.error('Error al preparar el PDF:', e);
              this.openSnackBar("Ocurrió un error al preparar el PDF.", "");
            } finally {
              this.isLoading = false;
            }
          },
          error: (err) => {
            console.error('Error al obtener archivo:', err);
            this.openSnackBar("Ocurrió un error al descargar el PDF.", "");
            this.isLoading = false;
          }
        });
  
    } catch (error) {
      console.error("Error al procesar la solicitud:", error);
      this.openSnackBar("Ocurrió un error al procesar la solicitud.", "");
      this.isLoading = false;
    }
  }
  
  /*private async findCertificado(codigoSeguridad: string, codigoHash: string, nroCertificado: string, nroSuministro: string) {
    this.isLoading = true;
    this.loadingText = 'Buscando información del certificado...';
    try {
      //console.log("CertificadosComponent / findCertificado...");
      const list: any = await this.certificadoService.getPromiseInicial(
        nroCertificado,
        nroSuministro,
        codigoHash,
        codigoSeguridad
      );
      //console.log("CertificadosComponent / findCertificado - Registros encontrados", list.length, list);

      if (list.length!=undefined) {
        if(list[0].TIPO_SERVICIO =="VRI"){
          this.urlPDF = await this.sanitizarURL(list[0].URL_CERTIFICADO);
          this.view = false;
        }else{
          const loginExitoso = await this.authService.login('WEB', 'DGONZALES', '123Tdem').toPromise();
          
          const tokenOneDrive = await this.onedriveService.getTokenOneDrive(1,1,'WEB', 'DGONZALES');
          //console.log("CertificadosComponent / findCertificado - Obtener Token del Onedrive", tokenOneDrive);

          
          let rutaCorregida ="";
          if(String(list[0].RUTA_ONE_DRIVE).includes(list[0].NRO_CERTIFICADO)){
            rutaCorregida = String(list[0].RUTA_ONE_DRIVE).replace(list[0].NRO_CERTIFICADO, list[0].SUMINISTRO)
          }else{
            rutaCorregida = list[0].RUTA_ONE_DRIVE;
          }

          const ultimaBarra = rutaCorregida.lastIndexOf("/");

          const ruta = rutaCorregida.substring(0, ultimaBarra);
          const archivo = rutaCorregida.substring(ultimaBarra + 1);

          const oneDriveParams = {
            idUserOneDrive: 'b98e8622-72e8-482c-ab22-67bba826531e',
            ruta: ruta,//'CALIDAD/SIG-2025/SERVICIO DE VERIFICACIONES/200 VRF CHICLAYO/SEMESTRE I/03. MARZO/F-VRF-02 CERTIFICADO DE VERIFICACION/P227/SEMANA 08/CAJAMARCA/ELVER HERRERA',
            fileName: archivo//'36915038.pdf'
          };

          //console.log("CertificadosComponent / findCertificado - Parametros para buscar en Onedrive", oneDriveParams);

          this.onedriveService.getFileFromOneDrive(oneDriveParams.idUserOneDrive, oneDriveParams.ruta, oneDriveParams.fileName, tokenOneDrive.accessToken).subscribe({
            next: async (blobPDF: Blob) => {
              //console.log("CertificadosComponent / findCertificado - Archivo obtenido en formato BLOB", blobPDF);
              
              this.urlPDF = await this.sanitizarURL(URL.createObjectURL(blobPDF));
              this.view = false;
            },
            error: (err) => {
              console.error('Error al obtener archivo:', err);
              this.openSnackBar("Ocurrió un error al procesar la solicitud.", JSON.stringify(err));
            }
          });
        }
      } else {
        console.error("Error al procesar la solicitud:");
        this.openSnackBar("No se encontro el certificado con los datos ingresados.", "");
      }
    } catch (error) {
      console.error("Error al procesar la solicitud:", error);
      this.openSnackBar("Ocurrió un error al procesar la solicitud.", JSON.stringify(error));
    }
  }*/
  async showPdf(fileUrl: string) {
    try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
            throw new Error(`Error al descargar el archivo: ${response.statusText}`);
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        return this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    } catch (error) {
        console.error('Error al procesar el archivo PDF:', error);
    }
}
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ["success-snackbar"],
      duration: 10000
    });
  }

  async sanitizarURL(url: string): Promise<SafeResourceUrl> {
    await this.simulateAsyncOperation();
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  simulateAsyncOperation(): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 1000); // Simula un retraso de 1 segundo
    });
  }

  exit(){
    this.router.navigate(['/certificados']).then(() => {
      // Luego recargar la página
      window.location.reload();
    });
  }

  credentials = { username: '', password: '' };


} 